import createStore from "./createStore";

const useUpdateNav = createStore((get, set) => ({
	nav: 0,
	updateNav: (el) => set(store => ({...store, nav: ++store.nav }))
}));

export default useUpdateNav;